import { tenantId } from '../settings';

const MISC_ENDPOINT = 'https://misc-rendering.documents.cimpress.io';

export const renderingUrl = 'https://rendering.documents.cimpress.io';

export function generatePreview({ url, width, height, quality, background, image, format, instructionsUri = `${MISC_ENDPOINT}/simpledoc?sku=VIP-44517` }) {
    const imageuris = image ? `&imageuris=${encodeURIComponent(image)}` : '';
    const instructions = `instructions_uri=${encodeURIComponent(`${instructionsUri}${imageuris}`)}`;
    const scene = url ? `&scene=${encodeURIComponent(url)}` : '';
    const dimension = `${width ? `&width=${width}` : ''}${height ? `&height=${height}` : ''}`;
    const qual = quality && format === 'jpg' ? `&quality=${quality}` : '';
    const imageFormat = `&format=${format || 'png'}`;
    const color = background ? `&bgcolor=${background}` : '';
    return `${renderingUrl}/v1/${tenantId}/preview?${instructions}${scene}${color}${dimension}${imageFormat}${qual}`;
}



// WEBPACK FOOTER //
// ./src/services/renderingClient.js